export default __webpack_public_path__ + "static/media/King's Feast.da409115.jpg";